import React, { useState, useMemo, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Search from "../search";
import { carrierService } from "/app/src/services";
import { useTranslation } from "react-i18next";
import { Carrier as CarrierType } from "/app/src/models";
import { createColumnHelper } from "@tanstack/react-table";
import Table from "/app/src/components/generic/tables/table";
import { useSortUpgrade } from "/app/src/hooks/useSortUpgrade";
import usePaginatedData from "/app/src/hooks/usePaginatedData";
export default function Carriers() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columnHelper = createColumnHelper<CarrierType>();
  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        id: "name",
        cell: (info) => info.getValue(),
        header: () => t("translation:name"),
      }),
    ],
    [columnHelper, t],
  );
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [sort, setSort] = useSortUpgrade([]);
  const [searchString, setSearchString] = useState("");

  const goToCarrier = useCallback(
    (carrierId: number) => {
      navigate(`/explorer/carriers/${carrierId}`);
    },
    [navigate],
  );

  const {
    data: carriers,
    count: carriersCount,
    isFetching,
  } = usePaginatedData<CarrierType>({
    queryKey: ["carriers"],
    searchString,
    page,
    pageSize,
    sort,
    service: carrierService,
  });

  return (
    <div className="explorer">
      <Helmet>
        <title>{t("translation:carriers")} - ItemPath</title>
      </Helmet>
      <div className="search box">
        <Search setSearchString={setSearchString} />
      </div>
      <Table
        loading={isFetching}
        rows={carriers}
        tableColumns={columns}
        length={carriersCount}
        sort={sort}
        setSort={setSort}
        paginationEnabled={{
          currentPage: page,
          pageSize,
          setPage,
          setPageSize,
        }}
        enableRowSelection
        rowClicked={goToCarrier}
        emptyText={t("translation:no_carriers")}
      />
    </div>
  );
}
